import { render, staticRenderFns } from "./NavRegionsLinkEntry.vue?vue&type=template&id=27906809&scoped=true"
import script from "./NavRegionsLinkEntry.vue?vue&type=script&lang=js"
export * from "./NavRegionsLinkEntry.vue?vue&type=script&lang=js"
import style0 from "./NavRegionsLinkEntry.vue?vue&type=style&index=0&id=27906809&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27906809",
  null
  
)

export default component.exports